import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/data/http/base-http.service';
import { CompanyPreference } from '@core/models/preference/company-preference';
import { UserPreference } from '@core/models/preference/user-preference';
import { Observable } from 'rxjs';

@Injectable()
export class PreferenceDataService extends BaseHttpService {

    private urls = { prefs: '/prefs/:id' };

    fetchUserPrefs(userId: string): Observable<any> {
        return this.get(this.urls.prefs.replace(':id', userId));
    }

    fetchCompanyPrefs(companyId: string): Observable<any> {
        return this.get(this.urls.prefs.replace(':id', companyId));
    }

    saveUserPrefs(prefs: { prefs: UserPreference }, userId: string): Observable<any> {
        return this.post(this.urls.prefs.replace(':id', userId), prefs);
    }

    saveCompanyPrefs(prefs: { prefs: CompanyPreference }, companyId: string): Observable<any> {
        return this.post(this.urls.prefs.replace(':id', companyId), prefs);
    }
}